import {
  Button,
  DialogActions,
  DialogContent,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@mui/material";
import moment from "moment";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getAccidentLogs } from "../../../../actions/accidents"; // Acción de Redux para obtener logs.
import CustomDialog from "../../../commons/dialog/customDialog";
import CircularLoading from "../../../commons/loadingData/circularLoading";
import { StyledEditLogsContainer } from "../../../styled/logs";

const EditLogsContainer = ({ accident, handleClose }) => {
  const dispatch = useDispatch();

  const logs = useSelector((state) => state.accidents.logs);

  useEffect(() => {
    if (accident) {
      // Despacha la acción para obtener los logs.
      dispatch(
        getAccidentLogs(accident.mlCloudCoreArtId, accident.idSiniestro),
      );
    }
  }, [accident]);

  return (
    <CustomDialog
      open={Boolean(accident)}
      onClose={handleClose}
      fullWidth
      maxWidth="sm"
    >
      <StyledEditLogsContainer.StyledDialogTitle>
        Historial de Cambios
      </StyledEditLogsContainer.StyledDialogTitle>
      <DialogContent>
        {logs.isFetching ? (
          <CircularLoading />
        ) : logs.data.length ? (
          <TableContainer>
            <StyledEditLogsContainer.StyledTable>
              <TableHead>
                <TableRow>
                  <TableCell>ID</TableCell>
                  <TableCell>Número Siniestro ART</TableCell>
                  <TableCell>Fecha</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {logs.data.map((log) => (
                  <TableRow key={log.id}>
                    <TableCell>{log.id}</TableCell>
                    <TableCell>{log.numeroSiniestroArt}</TableCell>
                    <TableCell>
                      {moment(log.fecha).format("DD/MM/YYYY, HH:mm")}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </StyledEditLogsContainer.StyledTable>
          </TableContainer>
        ) : (
          <StyledEditLogsContainer.NoDataTypography>
            No hay datos disponibles.
          </StyledEditLogsContainer.NoDataTypography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="primary">
          Aceptar
        </Button>
      </DialogActions>
    </CustomDialog>
  );
};

export default EditLogsContainer;
